import { render } from "./FormulairesLogic.vue?vue&type=template&id=64f7fa42"
import script from "./FormulairesLogic.vue?vue&type=script&lang=js"
export * from "./FormulairesLogic.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__